import { FE_SUPPORTED_LANGUAGES } from "@dfp/isomorphic-enums";

let resolveValidationLanguage: () => string | undefined = () => undefined;

export const setFrontendValidationLanguage = (
  resolver: () => string | undefined,
) => {
  resolveValidationLanguage = resolver;
};

export const getValidationLanguage = () => {
  const language = resolveValidationLanguage();

  return (
    FE_SUPPORTED_LANGUAGES.find((supported) => supported === language) ?? "en"
  );
};
